var ConfigManager = {


    retrieveAndSaveServerConfig: function () {
        if (this.isSingleConfiguration()) {
            var configuration = configurations[0];
            var serverUrl = configuration.serverUrl;
            var customerName = configuration.customerName;
            sessionStorage.setItem("serverUrl", serverUrl);
            sessionStorage.setItem("customerName", customerName);
        }
    },

    isSingleConfiguration: function () {
        return configurations.length == 1;
    }
};
